import { type TListItemProps } from './ListItem'

export const getSwitchedSections = ({
  detailBold,
  label,
  details,
  labelProps,
  detailsProps,
}: Pick<TListItemProps, 'detailBold' | 'label' | 'details' | 'labelProps' | 'detailsProps'>): Pick<
  TListItemProps,
  'label' | 'details' | 'labelProps' | 'detailsProps'
> => {
  if (detailBold) return { label: details, details: label, labelProps: detailsProps, detailsProps: labelProps }
  return { label, details, labelProps, detailsProps }
}
